import { type FC, Fragment } from "react";
import { Icon } from "@root/shared/components/Icon";
import { fontSize } from "@root/shared/styles/sprinkles.css";
import * as styles from "./styles.css";
import {
  type BeforeProps,
  type AfterProps,
  type PaginationItemProps,
  type PresentationProps,
} from "./type";

export const Presentation: FC<PresentationProps> = ({
  paginationData,
  currentPageNum,
  isShowAfterLeader,
  nextPagePath,
  prevPagePath,
}) => (
  <div className={styles.outer}>
    {paginationData.map(({ pageNum, path }, index) => (
      <Fragment key={path}>
        {index === 0 && (
          <Before
            isFirstPage={currentPageNum === 1}
            isShowLeader={pageNum !== 1}
            path={prevPagePath}
          />
        )}
        <PaginationItem isCurrent={pageNum === currentPageNum} pageNum={pageNum} path={path} />
        {index === paginationData.length - 1 && (
          <After
            isLastPage={currentPageNum === pageNum}
            isShowLeader={isShowAfterLeader}
            path={nextPagePath}
          />
        )}
      </Fragment>
    ))}
  </div>
);

// "<" アイコンつきの前のページを表示するボタン
const Before: FC<BeforeProps> = ({ isFirstPage, isShowLeader, path }) => (
  <>
    {isFirstPage ? (
      <span className={styles.item({ state: "isDisabled" })} data-is-disabled>
        <Icon name="arrow-light-left" fontSize={fontSize["fs-24"]} />
      </span>
    ) : (
      <>
        <a href={path} className={styles.item({ state: "default" })}>
          <Icon name="arrow-light-left" fontSize={fontSize["fs-24"]} />
        </a>
        {isShowLeader && <span className={styles.leader}>…</span>}
      </>
    )}
  </>
);

// ">" アイコンつきの前のページを表示するボタン
const After: FC<AfterProps> = ({ isLastPage, isShowLeader, path }) => (
  <>
    {isLastPage || !path ? (
      <span className={styles.item({ state: "isDisabled" })} data-is-disabled>
        <Icon name="arrow-light-right" fontSize={fontSize["fs-24"]} />
      </span>
    ) : (
      <>
        {isShowLeader && <span className={styles.leader}>…</span>}
        <a href={path} className={styles.item({ state: "default" })}>
          <Icon name="arrow-light-right" fontSize={fontSize["fs-24"]} />
        </a>
      </>
    )}
  </>
);

// ページ遷移用ボタン
const PaginationItem: FC<PaginationItemProps> = ({ isCurrent, pageNum, path }) => {
  if (isCurrent) {
    return <span className={styles.item({ state: "isCurrent" })}>{pageNum}</span>;
  }
  return (
    <a href={path} className={styles.item({ state: "default" })}>
      {pageNum}
    </a>
  );
};
